export default __webpack_public_path__ + "static/media/email-tickets.de20483a.png";